import Page from "../../Page";
import QRCodeStyle from "./QRCodeStyle";
import Api from "../../Api";
import HttpClient from "../../HttpClient";
import GetListQuery from "./GetListQuery";
import CreateAndPutPayload from "./CreateAndPutPayload";

// noinspection JSUnusedGlobalSymbols
class QRCodeStyleApi {
    /**
     * Get paginated items.
     * @author Kacper Faber
     * @since 0.1.4
     */
    static getList(query: GetListQuery): Promise<Page<QRCodeStyle>> {
        const url = Api.getUrl('/api/qr-code-style/');
        return HttpClient.get(url, { ...query });
    }

    /**
     * Delete style by ID.
     * @author Kacper Faber
     * @since 0.1.4
     * @param id
     */
    static deleteById(id: number): Promise<void> {
        const url = Api.getUrl(`/api/qr-code-style/${id}/`);
        return HttpClient.execNoContent(url, "DELETE", {}, {});
    }

    /**
     * Delete style from API.
     * @author Kacper Faber
     * @since 0.1.4
     * @param object QRCodeStyle with valid ID
     */
    static delete(object: QRCodeStyle): Promise<void> {
        const url = Api.getUrl(`/api/qr-code-style/${object.id}/`);
        return HttpClient.execNoContent(url, "DELETE", {}, {});
    }

    /**
     * Create new QRCodeStyle.
     * @author Kacper Faber
     * @since 0.1.4
     * @param payload
     * @returns Created object
     */
    static create(payload: CreateAndPutPayload): Promise<QRCodeStyle> {
        const url = Api.getUrl('/api/qr-code-style/');
        return HttpClient.post(url, {}, { ...payload });
    }

    /**
     * Get QRCodeStyle by ID.
     * @author Kacper Faber
     * @since 0.1.8
     * @param id
     */
    static getById(id: number | string): Promise<QRCodeStyle> {
        const url = Api.getUrl(`/api/qr-code-style/${id}/`);
        return HttpClient.get(url, {});
    }

    /**
     * Updates QRCodeStyle by ID.
     * @param id
     * @param payload
     */
    static updateById(id: number, payload: CreateAndPutPayload): Promise<QRCodeStyle> {
        const url = Api.getUrl(`/api/qr-code-style/${id}/`);
        return HttpClient.put(url, {}, { ...payload });
    }
}

// noinspection JSUnusedGlobalSymbols
export default QRCodeStyleApi;

// TODO: All payloads !!!
//  - Skip undefined fields.